import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Group from './components/Group';
import Color from './components/Color';
import Question from './components/Question';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <h3 className='mb-3'>Settings</h3>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Group" {...a11yProps(0)} />
          <Tab label="Questions" {...a11yProps(1)} />
          {/* <Tab label="Colors" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Group />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Question />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Color />
      </TabPanel>
    </Box>
  );
}